import axios from '../config/axios'

export const getAdditionalFactsheet = ()=> axios.get(`/participant/additionalFactsheet`)
export const putAdditionalFactsheetAnswer = (data)=> axios.put(`/participant/additionalFactsheet`, data)
export const getParticipantFactsheet = ()=> axios.get('/participant/factsheet')
export const getParticipantPhoto = ()=> axios.get('/participant/photo')
export const putParticipantFactsheet = (data)=> axios.put(`/participant/factsheet`, data)
export const postParticipantPhoto = (formData) => axios.post(`/participant/photo`, formData)